/*
Looking to add a new experiment?
Read this - https://github.com/wix-private/wix-answers/blob/master/answers-client/core/experiments/README.md
*/
export var featureToggleMap = {
    TeamMembersV2: {
        petriSpec: "specs.TeamMembersV2",
        default: false,
        description: "Displays New Team Members Pages (Members and Groups)",
        mergeJira: "https://app.asana.com/0/1204015372890419/1204015101392971"
    },
    TranslationQuickFixes: {
        petriSpec: "specs.TranslationQuickFixes",
        default: false,
        description: "quick fixes for translation task and translation screen",
        mergeJira: "https://app.asana.com/0/1204064551274092/1204269204191403"
    },
    AiGenerateContent: {
        petriSpec: "specs.AiGenerateContent",
        default: false,
        description: "AI generate content in the article page",
        mergeJira: "https://app.asana.com/0/1204064551274092/1204269204191403"
    },
    AgentModalSkills: {
        petriSpec: "specs.AgentModalSkills",
        default: false,
        description: "Render Agent Modal Skills Cards",
        mergeJira: "https://app.asana.com/0/1204015372890419/1204015101392971"
    },
    FeatureRequestETA: {
        petriSpec: "specs.FeatureRequestETA",
        default: false,
        description: "Displays Article Feature Request ETA ",
        mergeJira: "https://app.asana.com/0/1203323295504364/1203357737516543"
    },
    SkillBaseRouting: {
        petriSpec: "specs.SkillBaseRouting",
        default: false,
        description: "To display the skills card on the agent modal + required skills on OI info panel",
        mergeJira: "https://app.asana.com/0/1201358638192174/1203058073336995"
    },
    BoWixRoadmap: {
        petriSpec: "specs.BoWixRoadmap",
        default: false,
        description: "Back office wix roadmap page",
        mergeJira: "https://app.asana.com/0/1201358638192174/1203081907597672"
    },
    DisabledAvailableWhenNoChannel: {
        petriSpec: "specs.DisabledAvailableWhenNoChannel",
        default: false,
        description: "Enables feature for disabled available btn for agent subscribed to no channels",
        mergeJira: "https://app.asana.com/0/0/1202835242387247/f"
    },
    NewCallCreditsFlow: {
        petriSpec: "specs.NewCallCreditsFlow",
        default: false,
        description: "Enables updated call credits flow",
        mergeJira: "https://app.asana.com/0/1201257251712332/1202637318505467"
    },
    OmniChannelDashboard: {
        petriSpec: "specs.OmniChannelDashboard",
        default: false,
        description: "Omnichannel dashboard page",
        mergeJira: "https://app.asana.com/0/1201257251712332/1202006686222086"
    },
    ChatTransfer: {
        petriSpec: "specs.ChatTransfer",
        default: false,
        description: "Enables Chat transfer capability",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201920516694870"
    },
    RealTimeViewsCounters: {
        petriSpec: "specs.RealTimeViewsCounters",
        default: false,
        description: "Realtime counters for saved views",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202173716626335/f"
    },
    EmailDashboard: {
        petriSpec: "specs.EmailDashboard",
        default: false,
        description: "Email Dashboard page in control room",
        mergeJira: "https://app.asana.com/0/1201257251712332/1201927316840307/f"
    },
    NewSignatureMenu: {
        petriSpec: "specs.NewSignatureMenu",
        default: false,
        description: "Signature menu on agent menu",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202012744388096/f"
    },
    SlaAssigneeCondition: {
        petriSpec: "specs.SlaAssigneeCondition",
        default: false,
        description: "Displays new SLA assignee condition design",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201889656797600"
    },
    TicketLocaleFilter: {
        petriSpec: "specs.TicketLocaleFilter",
        default: false,
        description: "Add locale filter to ticket filters",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202029962503576"
    },
    SchedulesSLA: {
        petriSpec: "specs.SchedulesSLA",
        default: false,
        description: "Use multiple schedules in SLA Settings",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201811413105632"
    },
    TimelineImprovements: {
        petriSpec: "specs.TimelineImprovements",
        default: false,
        mergeJira: ""
    },
    HangupCallAgentNoAnswer: {
        petriSpec: "specs.HangupCallAgentNoAnswer",
        description: "hangup call when participant accepted call but participant's status is NO_ANSWER",
        default: false,
        mergeJira: "https://app.asana.com/0/1201146881163791/1202412057189158/f",
    },
    AutoRoutingFallbackHandler: {
        petriSpec: "specs.AotuRoutingFallbackHandler",
        default: false,
        description: "Add Fallback for AR when duplexer is down",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202040382134584/f"
    },
    SavedFiltersNewApi: {
        petriSpec: 'specs.SavedFiltersNewApi',
        default: false,
        description: 'Use new API for get saved filters',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201825333398917'
    },
    UpdateSavedFiltersNewApi: {
        petriSpec: 'specs.UpdateSavedFiltersNewApi',
        default: false,
        description: 'Use new API for update save filters (relevant only for tenants with new brand or locale filter',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1202047519187574'
    },
    NewTicketsCountApi: {
        petriSpec: 'specs.NewTicketsCountApi',
        default: false,
        description: 'use new API for tickets counter',
        mergeJira: 'https://app.asana.com/0/1201324218610427/1201739389847273/f',
    },
    EnableSimplifiedChinese: {
        petriSpec: 'specs.EnableSimplifiedChinese',
        default: false,
        description: 'Enables Articles CSV Import',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201686117324517'
    },
    categoryCsvImport: {
        petriSpec: 'specs.categoryCsvImport',
        default: false,
        description: 'Enables Articles CSV Import',
        mergeJira: 'no need, its internal'
    },
    BobSnippet: {
        petriSpec: 'specs.EnableBobSnippet',
        default: false,
        description: 'Will add a new special Bob snippet in call center insights',
        mergeJira: 'TBD'
    },
    UseWixRecorder: {
        petriSpec: 'specs.UseWixRecorder',
        default: false,
        description: 'Enables user session recording',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12045'
    },
    WidgetDraggable: {
        petriSpec: 'specs.EnableWidgetDraggable',
        default: false,
        description: 'Enables Widget V3 draggable feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9473'
    },
    WidgetIconMsg: {
        petriSpec: 'specs.EnableWidgetIconMsg',
        default: false,
        description: 'Enables Widget V3 icon msg settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9615'
    },
    SlaPolicies: {
        petriSpec: 'specs.SlaPolicies',
        default: false,
        description: 'Enables SLA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9712'
    },
    CustomFields: {
        petriSpec: 'specs.CustomFields',
        default: false,
        description: 'New Custom Fields Customers / Tickets',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9713'
    },
    ChatDevice: {
        petriSpec: 'specs.ChatDevice',
        default: false,
        description: 'Adds Chat Device to App for AutoAssign feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9978'
    },
    CallDelay: {
        petriSpec: 'specs.CallDelay',
        default: false,
        description: 'Enables call delay option for agents',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10946'
    },
    CustomFieldsLimit: {
        petriSpec: 'specs.CustomFieldsLimit',
        default: false,
        description: 'Increases custom fields limits',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11019'
    },
    ChatHotkeys: {
        petriSpec: 'specs.ChatHotkeys',
        default: false,
        description: 'Enables hotkeys for Chat Jira: WA-11436',
        mergeJira: 'TBD'
    },
    WhatsappAttachments: {
        petriSpec: 'specs.WhatsappAttachments',
        default: false,
        description: 'Enables Whatsapp attachments from the App to Whatsapp',
        mergeJira: 'TBD - internal'
    },
    RemoveCreditBlock: {
        petriSpec: 'specs.RemoveCreditBlock',
        default: false,
        description: 'Removes Ticket Page block when credits are insufficient.',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12357'
    },
    UploadZipFiles: {
        petriSpec: 'specs.UploadZipFiles',
        default: false,
        description: 'Enables uploading zip files (made for MH)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12135'
    },
    DashboardOutboundCallsAndTotalTime: {
        petriSpec: 'specs.DashboardOutboundCallsAndTotalTime',
        default: false,
        description: 'Patch for outbound sales MH account (and others) to include outbound calls to dashboard without adding filters to the UI. This also adds a "total call time" in the agents table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12295'
    },
    TicketsListNewPresenceComponent: {
        petriSpec: 'specs.TicketsListNewPresenceComponent',
        default: false,
        description: 'Enables new ticket list presence design',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12391',
    },
    EditCategoryIconSrc: {
        petriSpec: 'specs.EditCategoryIconSrc',
        default: false,
        description: 'Allows editing of category icon by source only, while keeping the icon key. Needed for new HC',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12515'
    },
    AnswersEnableChatWebhooksDigibankPOC: {
        petriSpec: 'specs.AnswersEnableChatWebhooksDigibankPOC',
        default: false,
        description: 'Enables chat webhooks for digibank POC - client and server',
        mergeJira: 'https://jira.wixpress.com/browse/WONT-BE-MERGED'
    },
    OneInbox: {
        petriSpec: 'specs.OneInbox',
        default: false,
        description: 'One Inbox page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12763'
    },
    AdvancedReportsWasabi: {
        petriSpec: 'specs.AdvancedReportsWasabi',
        default: false,
        description: 'wasabi insights reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13148'
    },
    CallTypeIndicator: {
        petriSpec: 'specs.CallTypeIndicator',
        default: false,
        description: 'add a call type column to call center',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13463'
    },
    WorkflowsBetaScenarios: {
        petriSpec: 'specs.WorkflowsBetaScenarios',
        default: false,
        description: 'Opening this experiment enables spotter scenarios that are still in dev',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14377'
    },
    OutboundChat: {
        petriSpec: 'specs.OutboundChat',
        default: false,
        description: 'Enables the option to open an outbound chat',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14070'
    },
    Partners: {
        petriSpec: 'specs.EnablePartners',
        default: false,
        description: 'enables partner users in app',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14133'
    },
    ForceHotjarTracking: {
        petriSpec: 'specs.ForceHotjarTracking',
        default: false,
        description: 'forces hotjar tracking',
        mergeJira: 'should never be merged'
    },
    CustomCompanyFieldsFilters: {
        petriSpec: 'specs.CustomCompanyFieldsFilters',
        default: false,
        description: 'Enables custom company fields in One Inbox Views',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14413'
    },
    NewLinesSettingsTable: {
        petriSpec: 'specs.NewLinesSettingsTable',
        default: false,
        description: 'New line settings table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14635'
    },
    AgentLocaleInterfacePicker: {
        petriSpec: 'specs.AgentLocaleInterfacePicker',
        default: false,
        description: 'Enables agent locale interface picker from user editor',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14721'
    },
    HC2SectionsCodeOverrides: {
        petriSpec: 'specs.HC2SectionsCodeOverrides',
        default: false,
        description: 'Enables code overrides for all sections in HCv2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14769'
    },
    APIReactQuery: {
        petriSpec: 'specs.AnswersAPIReactQuery',
        default: false,
        description: 'Wraps the API layer with React Query',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14859'
    },
    OneInboxCache: {
        petriSpec: 'specs.AnswersOneInboxCache',
        default: false,
        description: 'Enables the cache layer for OneInbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15339'
    },
    ChatbotBuilderPOC: {
        petriSpec: 'specs.ChatbotBuilderPOC',
        default: false,
        description: 'POC of chatbot builder',
        mergeJira: 'Wont merge'
    },
    WasabiMocks: {
        petriSpec: 'specs.WasabiMocks',
        default: false,
        description: 'wasabi mock reports for marketing use',
        mergeJira: 'wont merge'
    },
    WorkflowsBetaConditions: {
        petriSpec: 'specs.WorkflowsBetaConditions',
        default: false,
        description: 'Hides spotter conditions that did not go through QA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15171'
    },
    LogDuplexerMessages: {
        petriSpec: 'specs.LogDuplexerMessages',
        default: false,
        description: 'logs all duplexer messages for debug purposes',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15401'
    },
    CallcenterLogs: {
        petriSpec: 'specs.CallcenterLogs',
        default: false,
        description: 'enables debug logs for callcenter',
        mergeJira: 'TBD'
    },
    HCNextPrevArticle: {
        petriSpec: 'specs.HCNextPrevArticle',
        default: false,
        description: 'enables settings for next prev buttons',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15470'
    },
    DisableMobileLock: {
        petriSpec: 'specs.DisableMobileLock',
        default: false,
        description: 'disables mobile lock',
        mergeJira: 'TBD'
    },
    OneInboxChatStats: {
        petriSpec: 'specs.OneInboxChatStats',
        default: false,
        description: 'Enables Chat Stats in OI, requested by WIX',
        mergeJira: 'TBD'
    },
    ShowOneInboxVideo: {
        petriSpec: 'specs.ShowOneInboxVideo',
        default: false,
        description: 'Shows one inbox video on first time usage',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15725'
    },
    OneInboxChatSoundNotification: {
        petriSpec: 'specs.OneInboxChatSoundNotification',
        default: false,
        description: 'Play sound notification when there is a new chat in One Inbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15985'
    },
    CustomerPortalSettings: {
        petriSpec: 'specs.CustomerPortalSettings',
        default: false,
        description: 'Customer portal settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15991'
    },
    OneInboxChatStatusFilter: {
        petriSpec: 'specs.OneInboxChatStatusFilter',
        default: false,
        description: 'add filter by chat status to OI',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15979'
    },
    EmailOpenIndication: {
        petriSpec: 'specs.EmailOpenIndication',
        default: false,
        description: 'adds sent and read indication for agent replies',
        mergeJira: 'TBD'
    },
    CallCenterDashboard: {
        petriSpec: 'specs.CallCenterDashboard',
        default: false,
        description: 'Enables new Call Center Dashboard',
        mergeJira: ''
    },
    PaymentDetails: {
        petriSpec: 'specs.PaymentDetails',
        default: false,
        description: 'Enables Payment and Billing details',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16674'
    },
    WasabiCustomReports: {
        petriSpec: 'specs.WasabiCustomReports',
        default: false,
        description: 'enables WASABI custom reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16862'
    },
    LoggingACall: {
        petriSpec: 'specs.LoggingACall',
        default: false,
        description: 'Logging a Call feature for answers app (internal notes + custom fields)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17013'
    },
    SpotterEndChatAction: {
        petriSpec: 'specs.SpotterEndChatAction',
        default: false,
        description: 'new end chat action',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17142'
    },
    RealtimeTicketsPresence: {
        petriSpec: 'specs.RealtimeTicketsPresence',
        default: false,
        description: 'tickets RT presence',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17013'
    },
    HelpcenterSdkAddOnContactForm: {
        petriSpec: 'specs.HCOnContactFormRender',
        default: false,
        description: 'Adds onContactFormRendered method to Helpcenter sdk',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17127'
    },
    TwitterTicket: {
        petriSpec: 'specs.TwitterTicket',
        default: false,
        description: 'Twitter Ticket',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17295'
    },
    FourMillionBar: {
        petriSpec: 'specs.FourMillionBar',
        default: false,
        description: '$4,000,000',
        mergeJira: 'never'
    },
    SamlSsoLogin: {
        petriSpec: 'specs.SamlSsoLogin',
        default: false,
        description: 'Enables SAML SSO Login',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17393'
    },
    CsatConditions: {
        petriSpec: 'specs.CsatConditions',
        default: false,
        description: 'Adds CSAT conditions table to settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17715'
    },
    ChatDashboard: {
        petriSpec: 'specs.ChatDashboard',
        default: false,
        description: 'Chat dashboard page in control room',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17824'
    },
    HelpcenterContactFormEmailConfirmation: {
        petriSpec: 'specs.HelpcenterContactFormEmailConfirmation',
        default: false,
        description: 'Adds email confirmation to helpcenter contact form',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17888'
    },
    MultipleLocalesViews: {
        petriSpec: 'specs.MultipleLocalesViews',
        default: false,
        description: 'support multiple locales in views',
        mergeJira: 'https://jira.wixpress.com/browse/WA-17871'
    },
    PrivateViewsPermission: {
        petriSpec: 'specs.PrivateViewsPermission',
        default: false,
        description: 'Private views permission',
        mergeJira: 'https://jira.wixpress.com/browse/WA-18241'
    },
    CallPriorityScoring: {
        petriSpec: 'specs.CallPriorityScoring',
        default: false,
        description: 'Enables features based on calls priority scoring',
        mergeJira: 'https://jira.wixpress.com/browse/WA-18386'
    },
    SchedulesQueues: {
        petriSpec: 'specs.SchedulesQueues',
        default: false,
        description: 'adds multiple schedule functionality to queues',
        mergeJira: 'https://app.asana.com/0/1201284768785864/1201301842728280/f'
    },
    MultiBrandTicketing: {
        petriSpec: 'specs.MultiBrandTicketing',
        default: false,
        description: 'enables multi brand ticketing',
        mergeJira: 'https://app.asana.com/0/1201324221515916/1201370462400075/f'
    },
    MultiBrandTicketPermission: {
        petriSpec: 'specs.MultiBrandTicketPermission',
        default: false,
        description: 'add permission of change ticket name to roles and in UI',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1202104687796470/f'
    },
    SpotterCallTransferredScenario: {
        petriSpec: 'specs.SpotterCallTransferredScenario',
        default: false,
        description: 'Enables Spotter scenario 100',
        mergeJira: 'https://app.asana.com/0/1201044419602909/1201370361650162/f'
    },
    SpotterNewCallScenario: {
        petriSpec: 'specs.SpotterNewCallScenario',
        default: false,
        description: 'Enables Spotter scenario 101',
        mergeJira: 'https://app.asana.com/0/1201044419602909/1201370361650158/f'
    },
    SpotterChangePriorityScoreAction: {
        petriSpec: 'specs.SpotterChangePriorityScoreAction',
        default: false,
        description: 'Enables change priority score action in spotter',
        mergeJira: 'https://app.asana.com/0/1201044419602909/1201388120347802/f'
    },
    AutoRutingHideDeviceAfterDelay: {
        petriSpec: 'specs.AutoRutingHideDeviceAfterDelay',
        default: false,
        description: 'Do not show device afer 10sec delay',
        mergeJira: 'https://app.asana.com/0/1201324221515924/1201538735360714/f'
    },
    EmailTemplatesAdditionalToggles: {
        petriSpec: 'specs.EmailTemplatesAdditionalToggles',
        default: false,
        description: 'Adds toggles to Ticket Replied and Resolved',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1201244034457393/f'
    },
    ReCaptchaV3: {
        petriSpec: 'specs.ReCaptchaV3',
        default: false,
        description: 'Upgrade to use ReCaptchaV3',
        mergeJira: 'https://app.asana.com/0/1201324221515909/1201473019990380/f'
    },
    LinkArticleBrandPicker: {
        petriSpec: 'specs.LinkArticleBrandPicker',
        default: false,
        description: 'add brand picker to link article filters modal in ticket page',
        mergeJira: 'https://app.asana.com/0/1201047807369700/1201508256503815'
    },
    WidgetReCaptchaV3: {
        petriSpec: 'specs.WidgetReCaptchaV3',
        default: false,
        description: 'WidgetReCaptchaV3',
        mergeJira: 'https://app.asana.com/0/1201047807369700/1201508256503815'
    },
    SchedulesLines: {
        petriSpec: 'specs.SchedulesLines',
        default: false,
        description: 'adds multiple schedule functionality to lines',
        mergeJira: 'https://app.asana.com/0/1201324221515881/1201634249053405/f'
    },
    NewTicketModalMandatoryCustomFields: {
        petriSpec: 'specs.NewTicketModalMandatoryCustomFields',
        default: false,
        description: 'Enables showing mandatory custom fields in new ticket modal using backoffice SDK',
        mergeJira: 'https://app.asana.com/0/1201446965042756/1201669409499127'
    },
    KBTabs: {
        petriSpec: 'specs.KB-Tabs',
        default: false,
        description: 'Enables adding and editing Tabs component in KB articles',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1202795075660590/f'
    },
    InfiniteScrollRemoveContainer: {
        petriSpec: 'specs.InfiniteScrollRemoveContainer',
        default: false,
        description: 'enable to remove infinite scroll container safely',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1201763724509451'
    },
    SpotterScenario56: {
        petriSpec: 'specs.SpotterScenario56',
        default: false,
        description: 'Enables scenario 56 in Spotter - monitor chat transfers per agent',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202316369339997/f'
    },
    SpotterScenario58: {
        petriSpec: 'specs.SpotterScenario58',
        default: false,
        description: 'Enables scenario 58 in Spotter - reduce transferred chat wait time',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202327972919671/f'
    },
    SubSubCategoriesSettings: {
        petriSpec: 'specs.SubSubCategoriesSettings',
        default: false,
        description: 'Enabled subsub-categories helpcenter settings changes',
        mergeJira: 'https://app.asana.com/0/1201324221515895/1201899298987377/f'
    },
    LogMicrophonePermissions: {
        petriSpec: 'specs.LogMicrophonePermissions',
        default: false,
        description: 'Checks Agents microphone permission before accepting a call and logs it.',
        mergeJira: 'N/A'
    },
    NewTicketModalMultiLevelCustomFields: {
        petriSpec: 'specs.NewTicketModalMultiLevelCustomFields',
        default: false,
        description: 'multi level custom fields in the new ticket modal',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1202254670205839/f'
    },
    NewCategoriesPage: {
        petriSpec: 'specs.NewCategoriesPage',
        default: false,
        description: 'Enables new Categories page (app) with multi subcategory levels',
        mergeJira: 'https://app.asana.com/0/1201623832157956/1202411487734945/f'
    },
    OneInboxAdvancedSearch: {
        petriSpec: 'specs.OneInboxAdvancedSearch',
        default: false,
        description: 'One inbox advanced search',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1202696257889712/f'
    },
    AgentSlackChannel: {
        petriSpec: 'specs.AgentSlackChannel',
        default: false,
        description: 'Enables slackChannel field in agent modal',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1202988179514778/f'
    },
    UseLibbyRenderHtmlInArticleViewer: {
        petriSpec: 'specs.UseLibbyRenderHtmlInArticleViewer',
        default: false,
        description: 'use libbys renderHTML',
        mergeJira: ''
    },
    CallbackRequestV2: {
        petriSpec: 'specs.callBackRequestV2',
        default: false,
        description: 'Enables the new answer-integrated calllback request modal',
        mergeJira: '',
    },
    VistaEscalation: {
        petriSpec: 'specs.VistaEscalation',
        default: false,
        description: 'Enables Ticket escalation for vista',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1203370987766246/f',
    },
    ARCustomKeyTabsNotifier: {
        petriSpec: 'specs.ARCustomKeyTabsNotifier',
        default: false,
        description: 'Change the tabs notifier key to a specific key',
        mergeJira: 'https://app.asana.com/0/1203487025097086/1203583695397010/f',
    },
    ShowEOLBanner: {
        petriSpec: 'specs.showEOLBanner',
        default: false,
        description: 'Should show EOL Banner in answers BO',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1203486523137106/f',
    },
    ShowWordCount: {
        petriSpec: 'specs.showWordCount',
        default: false,
        description: 'Should show word count in article page and article list',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1203424805316047/f',
    },
    BulkActionTaskComplete: {
        petriSpec: 'specs.BulkActionTaskComplete',
        default: false,
        description: 'Shold show complete task in bulk action banner (ArticleList page)',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1203424805316027/f',
    },
    PrimaryArticleLabels: {
        petriSpec: 'specs.PrimaryArticleLabels',
        default: false,
        description: 'Show all primary article labels in translation mode. (Article page)',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1203424805316043/f',
    },
    SendingArticleChangeResolutionEmail: {
        petriSpec: 'specs.SendingArticleChangeResolutionEmail',
        default: false,
        description: 'roadmap email notification',
        mergeJira: 'https://app.asana.com/0/1201257251712349/1203977250129211',
    },
    StaffingGroupTicketPage: {
        petriSpec: 'specs.StaffingGroupTicketPage',
        default: false,
        description: 'StaffingGroup - changes on ticket page',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1204164181945230/f',
    },
    NewWrapupTimer: {
        petriSpec: 'specs.NewWrapupTimer',
        default: false,
        description: 'New component for wrapup counter after call',
        mergeJira: 'https://app.asana.com/0/1201146881163791/1204252553764947/f',
    },
    ArticleAbTest: {
        petriSpec: 'specs.ArticleAbTest',
        default: false,
        description: 'Enables article A/B testing environment',
        mergeJira: 'https://app.asana.com/0/1204015372890419/1204081629326081/f'
    },
    EnableWrapupUtilization: {
        petriSpec: 'specs.EnableWrapupUtilization',
        default: false,
        description: 'Shows the confirm modal at the end of the wrap-up time in OI',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1203829095840131/f',
    },
    HideSendAndAssignToggle: {
        petriSpec: 'specs.HideSendAndAssignToggle',
        default: false,
        description: 'Hides the send and assign toggle in one inbox ticket page',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1204086669827947/f',
    },
    OneInboxReorderSidebar: {
        petriSpec: 'specs.OIReorderSidebar',
        default: false,
        description: 'Places the salesforce integration below technical data',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1204116719481580/f',
    },
    EnableAISummaryInSavedReplies: {
        petriSpec: 'specs.EnableAISummaryInSavedReplies',
        default: false,
        description: 'Enables AI summary in saved replies',
        mergeJira: 'https://app.asana.com/0/1200368299997249/1204060089268300/f',
    },
    TwilioClientMinorVersion15: {
        petriSpec: 'specs.TwilioClientMinorVersion15',
        default: false,
        description: 'experimental'
    },
    RuleEngineSkillsSupport: {
        petriSpec: 'specs.RuleEngineSkillsSupport',
        default: false,
        description: 'Enables product skills (topics) condition & action in rule engine, action in macros',
        mergeJira: 'https://app.asana.com/0/1203328290934594/1204301528987355/f',
    },
    SpotterSkillConditions: {
        petriSpec: 'specs.SpotterSkillConditions',
        default: false,
        description: 'Enables ticket & agent product skill (topic) conditions in Spotter',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1204405910527020/f',
    },
    answersSunset: {
        petriSpec: 'specs.answersSunset',
        default: false,
        description: 'Enables answers sunset blocks',
        mergeJira: 'https://app.asana.com/0/1201257251712332/1204405910527020/f',
    },
    BoContentSnippets: {
        petriSpec: "specs.BoContentSnippets",
        default: false,
        description: "Back office Content Snippets page",
        mergeJira: "https://app.asana.com/0/1200368299997249/1202282890597270/f"
    },
    StaffingGroupHeaderOI: {
        petriSpec: "specs.StaffingGroupHeaderOI",
        default: false,
        description: "staffing group for new ticket anf callback request",
        mergeJira: "https://app.asana.com/0/1200368299997249/1204159933208156/f"
    },
    OneInboxProductSkillsFilter: {
        petriSpec: "specs.OneInboxProductSkillsFilter",
        default: false,
        description: "adds product skills tickets filter to one inbox",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204359813557345/f"
    },
};
//# sourceMappingURL=features.js.map